import ReactDOM from "react-dom";
import React from "react";

export default class InjectReactRenderer {
    constructor(cmp) {
        return class {
            constructor() {
                return new ReactCellRenderer(cmp)
            }

            getGui() { } //dummy for validation
        }
    }
}

class ReactCellRenderer {
    constructor(cmp) {
        this.cmp = cmp
    }

    init(params) {
        this.agGridProps = params;
        this.el = document.createElement('div');
    }

    getGui() {
        this.afterGuiAttached();
        return this.el;
    };

    afterGuiAttached() {
        const CMP = this.cmp;

        ReactDOM.render(<CMP {...this.agGridProps} />, this.el);
    };

    destroy() {
        ReactDOM.unmountComponentAtNode(this.el);
    }
}